function getKnifePrice(customizedKnife) {
  const defaultCurrencyCode = customizedKnife[0]?.cost?.subtotalAmount?.currencyCode || 'USD';

  return [customizedKnife, ...customizedKnife.parts].reduce(
    (acc, line) => {
      // Allow pseudo-lines for social share modal
      if (!line.merchandise) return acc;

      const lineVariants = line.merchandise.product.variants.edges;
      const variant = lineVariants.find(
        (el) => el.node.id === line.merchandise.id,
      );

      const variantPrice = Number(variant?.node?.priceV2?.amount) * line.quantity;
      const variantCompareAtPrice = Number(variant?.node?.compareAtPriceV2?.amount) * line.quantity;

      return {
        priceV2: {
          ...acc?.priceV2,
          amount: `${Number(acc?.priceV2?.amount) + variantPrice}`,
        },
        compareAtPriceV2: {
          ...acc?.compareAtPriceV2,
          amount: `${
            Number(acc?.compareAtPriceV2?.amount)
            + (variantCompareAtPrice || variantPrice)
          }`,
        },
      };
    },
    {
      priceV2: {
        amount: 0,
        currencyCode: defaultCurrencyCode,
      },
      compareAtPriceV2: { amount: 0, currencyCode: defaultCurrencyCode },
    },
  );
}

export default function parseCartItems(cartItems) {
  if (!cartItems) {
    return;
  }
  const normalProductAndCustomKnives = cartItems.filter((item) => {
    const threekitId = item.attributes.find(
      (attr) => attr.key === '_threekit_id',
    )?.value;
    const isMain = item.attributes.find(
      (attr) => attr.key === '_is_main',
    )?.value;
    const is2d = item.attributes.find(
      (attr) => attr.key === '_personalization',
    )?.value;

    return (threekitId && (isMain || is2d)) || (!threekitId && !isMain);
  });

  const groupedCartItems = normalProductAndCustomKnives.map((item) => {
    const knifeThreekitId = item.attributes.find(
      (attr) => attr.key === '_threekit_id',
    )?.value;

    if (knifeThreekitId) {
      const knifeParts = cartItems.filter((item) => {
        const partThreekitId = item.attributes.find(
          (attr) => attr.key === '_threekit_id',
        )?.value;
        const isMain = item.attributes.find(
          (attr) => attr.key === '_is_main' || attr.key === '_personalization',
        )?.value;

        return partThreekitId === knifeThreekitId && !isMain;
      });

      const customizedKnife = {
        ...item,
        customKnife: true,
        parts: knifeParts,
        get knifeConfiguration() {
          try {
            return JSON.parse(
              item.attributes.find((attr) => attr.key === '_knifeConfiguration')
                ?.value,
            );
          } catch (e) {
            return {};
          }
        },
      };

      return {
        ...customizedKnife,
        knifePrice: getKnifePrice(customizedKnife),
      };
    }

    return item;
  });

  // eslint-disable-next-line consistent-return
  return groupedCartItems;
}
